import React, { useState, useEffect } from "react";
import styled from "styled-components";
import background from "../../assets/meso-game-bg.png";
import LearnGame from "../../components/LearnGame";
import LearnGamePhonics from "../../components/LearnGamePhonics";
import PracticeGame from "../../components/PracticeGame";
import KeyboardStage3 from "../../components/KeyboardStage3";
import Keyboard from "../../components/Keyboard";
import useTopicQuestions from "../../hooks/useTopicQuestions";
import useSpeech from "../../hooks/useSpeech";
import { Scale } from 'react-scaling';
import { Textfit } from 'react-textfit';
import Calculator from "../../components/CalculatorLearn";
import axios from "axios";
//import useAuth from "../../../auth/hooks/useAuth";

var { questions } = [];

//Vars for round4
var allowAnswer = false;
var blankquestion = null;
var incorrectQ = 0;
var lastIncorrectValue = 0;
var canDestroy = false;



export default function Game({ ...props }) {
   // const { state: authState } = useAuth();
    const [loading, setLoading] = useState(true);
    const [correctQuestions, setCorrectQuestions] = useState([]);
    const [incorrectQuestions, setIncorrectQuestions] = useState([]);
    const [loadedQuestions, setLoadedQuestions] = useState([]);
    const [score, setScore] = useState(0);
    const [combo, setCombo] = useState(0);
    const [maxCombo, setMaxCombo] = useState(0);
    const [feedback, setFeedback] = useState([]);
    const [nofeedback, setNoFeedback] = useState([]);
    const [status, setStatus] = useState("LOADING");
    const [setup, setSetup] = useState(false);
    const [custom, setCustom] = useState(false);
    const [waitTime, setWaitTime] = useState(-10);
    const [endgame, setEndGame] = useState(false);

    const[showColouredFeedback, setColouredFeedback] = useState(false);

    const [refresh, setRefresh] = useState(false)

    const [batTime, setBatTime] = useState(2);
    //const {useTop} = useTopicQuestions();
    //console.log(loading);

    var timer = -1;
    if(props.timelimit > 0)
    {
        timer = props.timelimit;
    }
    else
    {
        timer = 240;
    }

    var questionMax = -1;
    if(props.minimum > 0)
    {
        questionMax = props.minimum;
    }

    function shuffleArray(array) {
        for (let i = array.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
      }

      function GenerateRandom(min, max) {
        return Math.floor(Math.random() * (max - min) + min);
      }

    //console.log(props);
    if (setup == false) {
      console.log(props);
        questions = undefined;
        if (questions == undefined && props.customlist == undefined && setup == false) {
            var params = {
                topics: props.topics,
                game_type: "multiplication"
            };
            try {
                (async () => {
                    const response = await axios({
                        method: "get",
                        url: `${process.env.REACT_APP_OAUTH_URL}/lite/topics/questions`,
                        params
                    });
                    setStatus("OK");
                    console.log(response.data);
                   setLoadedQuestions(response.data);
                })();
            } catch (e) {
                setStatus("ERROR");
            }
            setCustom(false);
            setSetup(true);
            //newQuestion();
        } else if (setup == false && props.customlist != undefined) {
            questions = [];
            var list = props.customlist;
            list.forEach(q => {
                var reg = new RegExp("\\b" + q.word + "\\b", 'i');
                let questionText = q.question.replace(reg, "$");//do replacement thing
                let qobj = { "question_key": q.id, "sentence": questionText, "word": q.word, "topic_key": q.id, "topic_id": q.id }
                questions.push(qobj);
            });
            setStatus("OK");
            setCustom(true);
            setSetup(true);
        }
    }

    const { sayWord } = useSpeech();
    const [currentQuestion, setCurrentQuestion] = useState(null);
    const [wordToSay, setWordToSay] = useState("");
    const [extraChars, setExtraChars] = useState([]);
//NEW VARIABLES
    const[qnum, setQuestionNumber] = useState(-1);
    const [completedQuestions, setCompletedQuestions] = useState([]);
    const [wrongQuestions, setWrongQuestions] = useState([]);
    const [round, setRound] = useState(1);
    const [showWord, setShowWord] = useState(true);//whether to show the word or not
    const [wordTimer, setWordTimer] = useState(-10);//timer to hide the word
    const [showCompleteScreen, setShowCompleteScreen] = useState(false);//shows some round complete screen after each round

    //ROUND 4
    const [answerTimer, setAnswerTimer] = useState(-10);//timer to hide the word

    const [inputLetters, setInputLetters] = useState([]);//this is an array of letters, it will have values of answer: and value:, when a new question is created it will create a blank array of it


    //timer for showing the word
    useEffect(() => {
        if (wordTimer > 0) {
            var wordtimerID = setInterval(() => reduceWordTimer(), 1000);
            return () => {
                clearInterval(wordtimerID);
            };
        } else if (wordTimer != -10) {
            setShowWord(false);
        }
      },[wordTimer]);

      function reduceWordTimer() {
        console.log(wordTimer);
        setWordTimer(wordTimer - 1);
      }

          //timer for questions
    useEffect(() => {
      if (answerTimer > 0 && !endgame) {
          var answerTimerID = setInterval(() => reduceAnswerTimer(), 1000);
          return () => {
              clearInterval(answerTimerID);
          };
      } else if (answerTimer != -10) {
          //setShowWord(false);
        setWrongQuestions([...wrongQuestions, currentQuestion.answer]);
        setIncorrectQuestions([...incorrectQuestions, currentQuestion]);
        if (combo === 0 && score >= 10) {
          setScore(score - 10);
        } else {
          setCombo(0);
        }

        //newQuestion();
        setFeedback([...feedback, ""]);
        //setColouredFeedback(true);
      //setWaitTime(2);
          checkResult();
          newQuestion();
          
      }
    },[answerTimer]);

    function reduceAnswerTimer() {
    if(waitTime <= 0 && allowAnswer){
      console.log(answerTimer);
      setAnswerTimer(answerTimer - 1);
      }
    }

    function newQuestion() {
        if (!endgame) {
            console.log("new question");
            if (round == 1) {

                let tqnum = qnum + 1;
                console.log(questions);
                setQuestionNumber(tqnum);
                setQuestionNumber(tqnum);
            }
            if (round == 2 || round == 3) {
                let tqnum = GenerateRandom(0, questions.length);
                setQuestionNumber(tqnum);
                setQuestionNumber(tqnum);
            }
            if (round == 4) {
                let tqnum = GenerateRandom(0, questions.length);
                setQuestionNumber(tqnum);
                setQuestionNumber(tqnum);
            }
        }
        //needs a better check for when you have answered up to questions.length but don't have them all right, needs to go back and go to the first question that isn't included in teh completedquestions array
        //use effects to generate new question by generating a new question whenever tqnum changes
    }

    function ContainsAmount(answer){
      let amount = 0;

      for (let i = 0; i < completedQuestions.length; i++) {
        if (completedQuestions[i] == answer){
          amount++;
        }
      }
      return amount;
    }

    useEffect(() => {
        console.log("qnum changed");
        if (status == "OK"){
                //check if completed already then increment again if completed already until greater than questions.length
                console.log("comparing lengths");
                console.log(qnum)
                console.log(questions.length);
            if (qnum < questions.length){
                if (ContainsAmount(questions[qnum].answer) >= 4){
                    console.log("completed questions contains it");
                    newQuestion();
                }else{
                    var sample = questions[qnum];
                    //SHOW WORD
                    
                    if (round == 1){
                        setShowWord(true);
                        setWordTimer(2);
                    }else if (round == 2){
                      setShowWord(true);
                      setWordTimer(2);
                    }else if (round == 3){
                      setShowWord(false);
                    }
                    else if (round == 4){
                      setShowWord(false);
                      console.log("ok");
                      setAnswerTimer(12);
                    }

                    console.log("CURRENT QUESTION");
                    console.log(sample);
                    setCurrentQuestion(sample);
                    //check if wrong 6 times
                    console.log("COMPELTED:");
                    console.log(completedQuestions);
                    console.log("WRONG:");
                    console.log(wrongQuestions);
                     let wrongCount = 0;
                     for (let i = 0; i < wrongQuestions.length; i++) {
                       if (sample.answer ==  wrongQuestions[i]){
                         wrongCount++;
                       }
                     }
                     console.log(wrongCount);
                     if (wrongCount >= 6){
                      setCompletedQuestions([...completedQuestions, sample.answer]);
                     }
                }
            }
            else{
                console.log("qnum is greater");
                setQuestionNumber(0);
            }
        }
    }, [qnum]);

    useEffect(() => {
        if (status == "OK"){
            if (completedQuestions.length != questions.length){
                if(round != 4){
                 newQuestion();
				}                
            }else{
                CheckRoundSystem();
            }
        }
    }, [completedQuestions]);
    

    

    //will check if each question is completed of that round, otherwise populate the question list with ones not correct yet
    function CheckRoundSystem(){
        console.log("checking round system");
        console.log(completedQuestions);
        console.log(questions);
        if (completedQuestions.length == questions.length){
            //next round
            if (round != 4){
              setShowCompleteScreen(true);
            } else {
              setEndGame(true);
              setAnswerTimer(-10);
            }
            
        }else{
            setQuestionNumber(0);
            newQuestion();
        }
    }

    function NextRound(){
            if (round == 3){//IF NEXT ROUND IS 4 then add more to the questions
              for (let i = 0; i < 6; i++) {
                const question =   questions[i];
                questions.push(question);
              }
              blankquestion = true;
            }
            if (round == 4){
              setEndGame(true);
            }
            else{
              setShowCompleteScreen(false);
              setCompletedQuestions([]);//blank this array
              setWrongQuestions([]);
              setRound(round+1);
              console.log("ROUND COMPLETED");
              console.log(round);
              setQuestionNumber(0);
            }
    }

    function resetAllowAnswer(){
    allowAnswer = true;
    }

    //Called on click
  async function checkResult(value, callback) {
    

    
    console.log(value);
    allowAnswer = false;
    var isCorrect = true;
    

    if (parseInt(currentQuestion.answer) === parseInt(value)) {
      setCompletedQuestions([...completedQuestions, value]);
      //console.log(value.value + " " + currentQuestion.word);
      //correct answer
      
      if (round == 4){

        let result = {
          question: currentQuestion.calculation,
          correct: currentQuestion.answer,
          incorrect: currentQuestion.answer
      };

        setCorrectQuestions([...correctQuestions, currentQuestion]);
        setNoFeedback([...feedback, result]);
      }
      let multiplier = combo > 0 ? combo + 1 : 1;
      multiplier = multiplier > 5 ? 5 : multiplier;
      setScore(score + multiplier * 10);

      if (combo < 99) {
        setCombo(combo + 1);
      }
      if (combo > maxCombo) {
        setMaxCombo(combo);
      }

      //moved this into a useeffect
      //newQuestion();
    }


    //incorrect answer
    else {

    incorrectQ += 1;

    if (incorrectQ == 18){
      setEndGame(true);
    }

      isCorrect = false;
      setWrongQuestions([...wrongQuestions, currentQuestion.answer]);
      if (round == 4){
          let result = {
            question: currentQuestion.calculation,
            correct: currentQuestion.answer,
            incorrect: value
        };
        setIncorrectQuestions([...incorrectQuestions, currentQuestion]);
        setCompletedQuestions([...completedQuestions, value]);
        setFeedback([...feedback, result]);
      }
        
      if (combo === 0 && score >= 10) {
        setScore(score - 10);
      } else {
        setCombo(0);
      }

      setColouredFeedback(true);
      
      //setWaitTime(2);
    }

     if(!allowAnswer && round == 4){
      setTimeout(resetAllowAnswer, 2000);
      setTimeout(newQuestion, 2000); //allow correct text to appear
	  }

    setRefresh(!refresh);

    if (callback) {
      await callback(isCorrect, currentQuestion.answer).then(() => {
          
      });
  } else {
      
  }

    //Generates a new question
    //newQuestion();
  }


  

    //     set the first question and setup questions
    useEffect(() => {
      if (loadedQuestions.length > 0){
          console.log("USE EFFECT HAPPENS");
          console.log(loadedQuestions);
          //SETUP QUESTIONS
          questions = [];
          //parse topic
          var timestable = loadedQuestions[0].topic_key.replace("mult", "");
          timestable = parseInt(timestable);
          //then check if lower or higher
          console.log(props);
          var split = props.type.split("|");
          if (split[1] == "lower"){//lower mult
            for (let x = 0; x < 2; x++) {//DOUBLE IT
              for (let i = 1; i < 7; i++) {
              let ques = { "question_key": loadedQuestions[0].id, "calculation": timestable.toString() + " x " + i.toString(), "answer": timestable * i, "topic_key": loadedQuestions[0].topic_key, "topic_id": props.topics[0]}
                questions.push(ques);
              }
            }
          }else{//upper mult
            for (let x = 0; x < 2; x++) {//DOUBLE IT
              for (let i = 7; i < 13; i++) {
              let ques = { "question_key": loadedQuestions[0].id, "calculation": timestable.toString() + " x " + i.toString(), "answer": timestable * i, "topic_key": loadedQuestions[0].topic_key, "topic_id": props.topics[0]}
                questions.push(ques);
              }
            }
          }

          console.log("GENERATED");
          console.log(questions);


          if (questions !== undefined && questions.length > 0) {
              console.log("set the first question");
              //setCurrentQuestion(questions[0]);
              newQuestion();
              console.log(currentQuestion);
              setLoading(false);
          }
      }
    }, [loadedQuestions]);

    function RESET(){
     canDestroy = false;
     incorrectQ = 0;
	}

    function background(){
        
        //normal image return
        var imageName = props.gameData.animation_path + "/Learn/";

        if (round == 1 && showCompleteScreen == false){
          imageName+= "Round1Idle.gif";
        }
        else if (round == 1 && showCompleteScreen == true){
            imageName += "Round1Transition.gif";
        }
        else if (round == 2 && showCompleteScreen == false){
          imageName+= "Round2Idle.gif"
        }
        else if (round == 2 && showCompleteScreen == true){
          imageName+= "Round2Transition.gif"
        }
        else if (round == 3 && showCompleteScreen == false){
          imageName+= "Round3Loop.gif";
        } else if (round == 3 && showCompleteScreen == true){
            imageName += "Round3Transition.gif";
        } else if (round == 4 && showCompleteScreen == false && !allowAnswer && canDestroy){ 
        imageName+= getProgressRound4Gifs(); 
        }

        //Transition to loop in set amount of time
        else if(round == 4 && showCompleteScreen == false && !allowAnswer && !canDestroy){
          imageName+= "Round4/Step1Start.gif";
		}
        else if(round == 4 && showCompleteScreen == false && allowAnswer){
            if(incorrectQ == 0){
            imageName+= "Round4/Step1Loop.gif";
		    }
            else{
            imageName+= getLoopGif();
		    }         
        } 

        //if it's not round 4 return normal image/gif
        //if it is round 4 then return an entire div section with the correct gif

        //Current issue: Getting an answer correct a second time can sometimes not play at all.
        //A ID key system has working but the calculator also updates, too.
        console.log("../../assets/" + imageName)
        if (round != 4) {
            return require("../../assets/" + imageName);
        }
        else {
            return (    
            <img src={require("../../assets/" + imageName)} style={{ backgroundSize: "fixed", height: "100%", width: "100%", zindex: 2}}  ></img>
            )
        }
        
	}


    //get the correct looped gif
    //get how many questions have been sumbitted incorrectly and then plus one to get proper loop
    //E.G. 1 quesiton wrong = get step2loop 
    function getLoopGif()
    {
        var imageName = "Round4/";
        imageName+= "Step" + (incorrectQ + 1) + "Loop.gif";  
        return imageName;
	}

    
   //get the next gif in the sequence should the player get an answer wrong or right.
    function getProgressRound4Gifs(path){

        //if the player sumbits incorrect then play destroy if not then play correct 
        var imageName = "Round4/"
        if(incorrectQ > lastIncorrectValue){
            imageName+= "Step" + incorrectQ + "DestroyedStart.gif";
		}else{
            imageName+= "Step" + (incorrectQ + 1) + "CorrectStart.gif";
		}
       return imageName;
	}



    //allow to play loop gif
    function EnableCalc(){
    allowAnswer = true;
    canDestroy = true;
    lastIncorrectValue = incorrectQ;
	}

     useEffect(() => {
    if(round == 4){
          setTimeout(EnableCalc, 2000);
    }
	}, [completedQuestions.length])



    useEffect(() => {
        if (waitTime > 0) {
            var waitttimerID = setInterval(() => reduceTimer(), 1000);
            return () => {
                clearInterval(waitttimerID);
            };
        } else if (waitTime != -10) {
            setColouredFeedback(false);
           // newQuestion();
        }
      },[waitTime]);


      function reduceTimer() {
        console.log(waitTime);
      setWaitTime(waitTime - 1);
      }


      function TimesTableTable(){
        if (currentQuestion == null){
          return <div></div>;
        }else{
          let html = '<div style="background: lightcyan; text-align: center; font-size: 40px">'+completedQuestions.length + "/"+ questions.length + '</div>';
          html += '<div style="user-select: none; background: white; width: 300px; display: block; text-align: center; font-size: 25px;">';
          if (round == 1 || round == 2){
          for (let i = 0; i < questions.length/2; i++) {
            if (questions[i].calculation != currentQuestion.calculation){
              html += '<span style="color: green">' + questions[i].calculation + "= " + questions[i].answer+"</span>";
            }else{
              if (showWord == true){
                html += '<span style="color: red">' + questions[i].calculation + "= " + questions[i].answer+"</span>";
              }else{
                html += '<span style="color: red">' + questions[i].calculation + "= ?</span>";
              }
            }
            html+= "<br>";
          }
        }

        if (round == 4){
          html+= "<span>"+answerTimer+"s</span>";
        }
          html+= "</div>"

          return (
            <div
            dangerouslySetInnerHTML={{__html: html}}
            />
            );
        }
      }





    return (
        <div>
            {round == 1 &&
             <LearnGame
             parent={props}
             correct={correctQuestions}
             incorrect={incorrectQuestions}
             score={score}
             defaultTimer={timer}
             questionLimit={questionMax}
             onBack={() => props.onBack()}
             loading={loading}
             feedback={feedback}
             nofeedback={nofeedback}
             questionFontSize="0.7em"
             restart={() => {
               setCombo(0);
               setScore(0);
               setCorrectQuestions([]);
               setIncorrectQuestions([]);
             }}
             homework_id={props.homework_id}
           >

                {showCompleteScreen == true &&
                    <div style={{ backgroundImage: `url(${background()})`, backgroundSize: "cover", height: "100%" }} >
                    <div style={{ justifyContent: "center", marginTop: "100px", display: "flex"}}>
                    <Button onClick={() => NextRound()}>  <Textfit mode="single" style={{ height: "100%" }}> Continue </Textfit></Button>
                    </div>
                </div>
            }
            {showCompleteScreen == false &&
             <div style={{ backgroundImage: `url(${background()})`, backgroundSize: "cover", height: "100%" }} >
                <Scale scaleTo={1720}>
                    <Body updateMe={refresh}>
                        {
                            currentQuestion != undefined && currentQuestion != null ?
                                <Calculator
                                    canAnswer = {!showWord}
                                    correctAnswer = {currentQuestion.answer}
                                    currentQuestion={[currentQuestion.calculation.split(" "), currentQuestion.answer]}
                                    onSubmitted={checkResult}
                                /> : null
                                
                            }
                            
                        {TimesTableTable()}
                        
                    </Body>
                </Scale>
            </div>
            }
           </LearnGame>
            }

{round == 2 &&
             <LearnGame
             parent={props}
             correct={correctQuestions}
             incorrect={incorrectQuestions}
             score={score}
             defaultTimer={timer}
             questionLimit={questionMax}
             onBack={() => props.onBack()}
             loading={loading}
             feedback={feedback}
             nofeedback={nofeedback}
             questionFontSize="0.7em"
             restart={() => {
               setCombo(0);
               setScore(0);
               setCorrectQuestions([]);
               setIncorrectQuestions([]);
             }}
             homework_id={props.homework_id}
           >

{showCompleteScreen == true &&
                    <div style={{ backgroundImage: `url(${background()})`, backgroundSize: "cover", height: "100%" }} >
                        <div style={{ justifyContent: "center", marginTop: "100px", display: "flex"}}>
                        <Button onClick={() => NextRound()}>  <Textfit mode="single" style={{ height: "100%" }}> Continue </Textfit></Button>
                        </div>
                    </div>
            }
            {showCompleteScreen == false &&
             <div style={{ backgroundImage: `url(${background()})`, backgroundSize: "cover", height: "100%" }} >
                <Scale scaleTo={1720}>
                    <Body updateMe={refresh}>
                        {
                            currentQuestion != undefined && currentQuestion != null ?
                                <Calculator
                                    canAnswer = {!showWord}
                                    correctAnswer = {currentQuestion.answer}
                                    currentQuestion={[currentQuestion.calculation.split(" "), currentQuestion.answer]}
                                    onSubmitted={checkResult}
                                /> : null
                                
                        }
                        {TimesTableTable()}
                        
                    </Body>
                </Scale>
            </div>
            }
           </LearnGame>
            }

{round == 3 &&
                     <LearnGame
                     parent={props}
                     correct={correctQuestions}
                     incorrect={incorrectQuestions}
                     score={score}
                     defaultTimer={timer}
                     questionLimit={questionMax}
                     onBack={() => props.onBack()}
                     loading={loading}
                     feedback={feedback}
                     nofeedback={nofeedback}
                     questionFontSize="0.7em"
                     restart={() => {
                       setCombo(0);
                       setScore(0);
                       setCorrectQuestions([]);
                       setIncorrectQuestions([]);
                     }}
                     homework_id={props.homework_id}
                   >
        
        {showCompleteScreen == true &&
                    <div style={{ backgroundImage: `url(${background()})`, backgroundSize: "cover", height: "100%" }} >
                        <div style={{ justifyContent: "center", marginTop: "400px", display: "flex"}}>
                        <Button onClick={() => NextRound()}>  <Textfit mode="single" style={{ height: "100%" }}> Continue </Textfit></Button>
                        </div>
                    </div>
                    }
                    {showCompleteScreen == false &&
                     <div style={{ backgroundImage: `url(${background()})`, backgroundSize: "cover", height: "100%" }} >
                        <Scale scaleTo={1720}>
                            <Body updateMe={refresh}>
                                {
                                    currentQuestion != undefined && currentQuestion != null ?
                                        <Calculator
                                            canAnswer = {!showWord}
                                            correctAnswer = {currentQuestion.answer}
                                            currentQuestion={[currentQuestion.calculation.split(" "), currentQuestion.answer]}
                                            onSubmitted={checkResult}
                                        /> : null
                                        
                                }
                                 {TimesTableTable()}
                            </Body>
                        </Scale>
                    </div>
                    }
                   </LearnGame>
            }
           {round == 4 &&
                     <LearnGame
                     parent={props}
                     correct={correctQuestions}
                     incorrect={incorrectQuestions}
                     score={score}
                     defaultTimer={timer}
                     end={endgame}
                     questionLimit={18}
                     onBack={() => { 
                      props.onBack();
                      RESET();
                     }}
                     loading={loading}
                     feedback={feedback}
                     nofeedback={nofeedback}
                     questionFontSize="0.7em"
                     restart={() => {
                       setCombo(0);
                       setScore(0);
                       setCorrectQuestions([]);
                       setIncorrectQuestions([]);
                       RESET();
                     }}
                     homework_id={props.homework_id}
                   >
        
        {showCompleteScreen == true &&
                    <CompleteScreen>
                        <Textfit mode="single" style={{height: "100%"}}>
                        Round {round} Complete!
                        </Textfit>
                    </CompleteScreen>
                    }
                    {showCompleteScreen == false &&
                    <div style={{ justifyContent: "center", height: "100%"}}>
                        <div>
                            {background()}       
                        </div>
                    <Scale scaleTo={1720}>
                        <div style={{backgroundSize: "fixed", zindex: 1, marginTop: "-850px"}}>
                            <Body answerTime={answerTimer}updateMe={refresh} >
                                    {
                                    currentQuestion != undefined && currentQuestion != null ?
                                            <Calculator
                                                blankme = {blankquestion}
                                                canAnswer = {allowAnswer}
                                                correctAnswer = {currentQuestion.answer}
                                                currentQuestion={[currentQuestion.calculation.split(" "), currentQuestion.answer]}
                                                onSubmitted={checkResult}
                                            /> : null      
                                    }
                            {TimesTableTable()}
                            </Body>           
                        </div>
                   </Scale> 
                   </div>    
        }
                 </LearnGame>
            }
        </div>
    );
}

const Button = styled.div`
        text-align: center;
        width: 20%;
        height: 100px;
        margin: 5px;
        color: #fff;
        user-select: none;
        background: rgb(234, 146, 19);
        background: linear-gradient(
          0deg,
          rgba(234, 146, 19, 1) 0%,
          rgba(255, 186, 32, 1) 100%
        );
        border: 2px solid #e88f12;
        box-sizing: border-box;
        border-radius: 0.25em;
        cursor: pointer;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
        margin - bottom: 0;
    }
  `;

const Body = styled.div`
    width: 100%;
    height: 100%;
    background-image: url("${props => props.gameBackground}");
    background-size: cover;
    background-position: 0px -1px;
    display: flex;
    justify-content: center;
    padding-top: 100px;
`;

const Result = styled.div`
    width: 100%;
    height: 100%;
    font-size: 5em;
    text-align: center;
    border: solid 2px #683d8c;
`;

const Combo = styled.div`
    background: #4391bb;
    width: 120px;
    height: 120px;
    border-radius: 75px;
    border: solid #204b7b 4px;
    display: flex;
    flex-direction: column;
    text-align: center;
    color: #fff;
    justify-content: center;
    font-weight: 600;
    margin-left: 50px;
`;

const Container = styled.div`
          width:100%%;
          height:95%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding-bottom:100px;
          `;

const TimesTable = styled.div`
          width:100%%;
          height:95%;
          background: #FFF;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding-bottom:100px;
          `;


const CompleteScreen = styled.div`
        font-size: 100px;
        align-items: center;
        text-align: center;
        width:50%%;
        height:300px;
        background: #FFF;
        margin: 15px 25px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-bottom:100px;
          `;

const Question = styled.div`
          background: #FFF;
          user-select: none;
          width: 90%;
          height: 120px;
          line-height: 90px;
          font-size: 4em;
          margin: 15px 25px;
          text-align: center;
          border: none;
          border-radius: 10px;
          user-select: none;
        `;

const Rune = styled.div`
        text-align: center;
        width: 100px;
        height: 150px;
        margin: 5px;
        color: #fff;
        background: rgb(234, 146, 19);
        background: linear-gradient(
          0deg,
          rgba(234, 146, 19, 1) 0%,
          rgba(255, 186, 32, 1) 100%
        );
        border: 2px solid #e88f12;
        box-sizing: border-box;
        border-radius: 0.25em;
        cursor: pointer;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
        margin - bottom: 0;
    }
  `;

  const EmptyRune = styled.div`
        text-align: center;
        width: 100px;
        height: 150px;
        margin: 5px;
        color: #fff;
        user-select: none;
        background: rgb(234, 146, 19);
        background: linear-gradient(
          0deg,
          rgba(200, 130, 19, 1) 0%,
          rgba(220, 170, 32, 1) 100%
        );
        border: 2px solid #e88f12;
        box-sizing: border-box;
        border-radius: 0.25em;
        cursor: pointer;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
        margin - bottom: 0;
    }
  `;
